import React/*, { Component }*/ from 'react'
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { Paragraph } from 'grommet/components/Paragraph';
import { Anchor } from 'grommet/components/Anchor';
import { DISPUTE } from '../Constants.js';




export const titleDatiResponsabile = (<Box>
    <Box align='start' style={{ padding: '24px 20px' }}>
        <Text className='titlehome'><h1>{sessionStorage.getItem('ebox') === "NO" ? DISPUTE.titleDispute : DISPUTE.titleDisputeReg}</h1></Text>
    </Box>
    <Box style={{ padding: '0 20px 50px 20px', textAlign: 'left'}} >
        <Text justify='left'><p>L'iscrizione con <b>codice Società</b> comporta <b>l'attivazione del servizio</b> per <b>tutti i punti vendita</b> collegati.</p></Text><br />
        <Text><p><b>IMPORTANTE!</b> Procedendo con l'iscrizione al servizio, dovrai indicare i <b>tuoi dati</b> come <b>'RESPONSABILE'</b>; potrai
                                            poi scegliere di <b>delegare la gestione delle richieste di documentazione</b> ad uno o più <b>GESTORI</b> (utenza societaria o punti vendita).</p></Text>
    </Box>
</Box>)


export const titleDatiGestore = (<Box>
    <Box align='start' style={{ padding: '24px 20px' }}>
        <Text className='titlehome'><h1>{DISPUTE.titleDispute}</h1></Text>
    </Box>
    <Box style={{ padding: '0 20px 50px 20px' }}>
        <Text className='subtitlehome'><h3>{DISPUTE.textDatiGestore}</h3></Text>
    </Box>
</Box>)


export const titleDatiRiepilogo = (<Box>
    <Box align='start' style={{ padding: '24px 20px' }}>
        <Text className='titlehome'><h1>{DISPUTE.titleDatiRiepilogo}</h1></Text>
    </Box>
</Box>)


export const info = (<Box pad='medium'>
    <Text className='titlehome' style={{ marginBottom: '5px' }}><h1>{DISPUTE.titleInfoDis}</h1></Text>
    <Text className='titleinfo'><h3>{DISPUTE.infoParagraph1}</h3></Text>
    <Paragraph className='textParagraph' style={{ margin: '20px 0' }}>
        {DISPUTE.infoParagraph2}
    </Paragraph>
    <Text className='titleinfo'><h5>{DISPUTE.subtitleInfoDis1}</h5></Text>
    <Paragraph className='textParagraph'>
        {DISPUTE.infoParagraph3}
    </Paragraph>
    <Text className='titleinfo'><h5>{DISPUTE.subtitleInfoDis2}</h5></Text>
    <Paragraph className='textParagraph preline' style={{ marginBottom: '24px' }}>
        {DISPUTE.infoParagraph4}
    </Paragraph>
    <Text className='titleinfo'><h5>{DISPUTE.subtitleInfoDis3}</h5></Text>
    <Paragraph className='textParagraph'>
        {DISPUTE.infoParagraph5}
    </Paragraph>
    <Text className='titleinfo'><h5>{DISPUTE.subtitleInfoDis4}</h5></Text>
    <Paragraph className='textParagraph preline' style={{ marginBottom: '24px' }}>
        {DISPUTE.infoParagraph6}
    </Paragraph>
    {sessionStorage.getItem('ebox') === 'NO' ?
        <Paragraph className='textParagraph'>
            {DISPUTE.infoParagraph7} <Anchor href='/DisputeOnline'>Clicca qui</Anchor>
        </Paragraph> : null}

</Box>)